import {getUserIdentityList} from "@/services/user.ts";
import {getUser} from "@/common/utils.ts";
import {queryAnchor} from "@/services/callCenter";

export const getUserIdentityFn = (roleCodes: string[] = ['ykf','ykfjl'], data = {}) =>{
  // roleCodes -- , 云客服: ['ykf','ykfjl']
  return getUserIdentityList({
    ...data,
    roleCodes,
    queryEmployee: true,
    queryOrg: true,
  })
}

export const getAnchorFn = (type: string, orgId?: string) =>{
  const userInfo = getUser();
  const id = orgId || userInfo?.orgId;
  // type -- 主播传ANCHOR，优化师传ADVERT，直播运营LIVE_OPERATION
  return queryAnchor(id, type)
}